import { useQuery } from "@tanstack/react-query";
import { fetchCollectionProducts } from "@/api/collections";

export function useCollectionProducts(collectionId: string | undefined) {
  return useQuery({
    queryKey: ["collections", collectionId, "products"],
    queryFn: () => fetchCollectionProducts(collectionId!),
    enabled: !!collectionId,
  });
}
